import type { ReactNode } from "react";
import {
  resolveSignUpConsentLabelHtml,
  type NormalizedSignUpConsentCheckboxConfig,
  type SignUpConsentBrandingVars,
} from "@/utils/sign-up-consent-checkboxes";

interface SignUpConsentCheckboxLabelProps {
  config: NormalizedSignUpConsentCheckboxConfig;
  branding: SignUpConsentBrandingVars;
  fallback: ReactNode;
}

export function SignUpConsentCheckboxLabel({ config, branding, fallback }: SignUpConsentCheckboxLabelProps) {
  const html = resolveSignUpConsentLabelHtml(config.labelHtml, branding);
  if (html) {
    return <span className="font-normal leading-snug" dangerouslySetInnerHTML={{ __html: html }} />;
  }
  return <span className="font-normal leading-snug">{fallback}</span>;
}
